module.exports = __webpack_public_path__ + "static/media/IMG-20191217-WA0010.2507d75f.jpg";